<template>
  <q-post-detail
    v-model="post"
    :categories="categories"
    :tags="tags"
    @persist-post="persist"
    @delete-post="deleteModel"
    @reject-post="reject"
  />
</template>

<script>
  import postDetail from "./postDetail";
  import caller from '../../../q-components/q-caller';


  export default {
    name: "QEditPost",

    components: {
      'q-post-detail': postDetail
    },

    props: {
      postId: {type: String, required: true},
    },

    data() {
      return {
        post: {},
        categories: [],
        tags: []
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize(to.params.postId));
    },

    methods: {
      initialize(postId) {
        caller.delegate('edms', 'getContentAsEditablePost', {
          id: postId
        }).then((res) => {
          caller.delegate('edms', 'getCategoriesForBlogList', {
            archive: 'blog'
          }).then((res1) => {

            caller.delegate('parameter', 'getAllItems', {
              parameterKey: 'CONTENT_TAG'
            }).then((res2) => {

              this.categories = res1.result.categories;
              this.post = res.result;
              this.tags = res2.result.items;

              this.$eventHub.$emit("onPageChanging", {
                caption: 'this.formStructure.caption',
                note: 'this.formStructure.note'
              })

            }).catch(() => {
            });

          }).catch(() => {
          });
        }).catch(() => {
        });
      },

      persist() {
        this.$delegate('edms', 'persistPost', {
          post: this.post
        }).then((result) => {
          this.$notify({
            title: this.$qt('model.successPersistTitle'),
            message: result.message,
            type: 'success'
          });
          this.readonly = true;
        }).catch(() => {
        });
      },
      reject() {
        this.$service('edms', 'content', 'reject', {
          modelId: this.post.id
        }).then((result) => {
          this.$notify({
            title: this.$qt('model.rejectedMessage'),
            message: result.message,
            type: 'success'
          });
          this.readonly = true;
        }).catch(() => {
        });
      },
      deleteModel() {
        this.$delegate('edms', 'deletePost', {
          postId: this.post.id
        }).then((result) => {
          this.$notify({
            title: this.$qt('model.deleteDialog.successMessage'),
            message: result.message,
            type: 'success'
          });
          this.readonly = true;
        }).catch(() => {
        });
      },
    }
  }

</script>

<style scoped>

</style>